import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';
import PlantServiceName, {PlantService} from "../../services/plant/plant.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import ShiftScheduleValidationServiceName, {ShiftScheduleValidationService}
  from "../../services/utility/shiftschedulevalidation.service";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import {TimeZoneService} from "../../services/utility/dateutility.service";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import template from './editPlant.tpl.html';

let requires = [PlantServiceName, LoaderServiceName, NewGuidServiceName, NotifyServiceName,
  ShiftScheduleValidationServiceName, UIUtilityServiceName];

interface ShiftTime {
  minute: number;
  clockTime: string;
}

interface EditPlantController {
  countRejectPercents: EnumOption[];
  morningMinutesTime: Date;
  form: angular.IFormController;
  plant: apsCommands.EditPlant;
  plantId: string;
  plants: apsViewModels.PlantInfo[];
  timeZones: string[];
  shiftTimes: ShiftTime[];
  deleteVisible: boolean;
  save(): void;
  close(): void;
  addShift(): void;
  deleteShift(shift: apsCommands.PlantCommandShiftSchedule): void;
}

export interface EditPlantData {
  plant: apsViewModels.PlantInfo;
  plants: apsViewModels.PlantInfo[];
}

export function openEditPlant(data: EditPlantData,
                              $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'EditPlantCtrl as editPlantCtrl',
    resolve: {
      data: function () {
        return data;
      }
    }
  }).result;
}

export default angular.module('aps.controller.editPlant', requires)
  .controller('EditPlantCtrl', editPlantCtrl)
  .name;

function editPlantCtrl(
  data: EditPlantData,
  $modalInstance: mm.foundation.modalInstance,
  plantService: PlantService,
  loaderService: LoaderService,
  newGuidService: NewGuidService,
  notifyService: NotifyService,
  shiftScheduleValidationService: ShiftScheduleValidationService,
  uiUtilityService: UIUtilityService
): EditPlantController {
  let vm = this as EditPlantController;

  function plantPersisted() {
    _.assign(data.plant, vm.plant);
    vm.close();
  }

  vm.close = function() {
    $modalInstance.close();
  };

  function deriveMinutesFromDate(date: Date) {
    let m = moment(date);
    return m.hour() * 60 + m.minute();
  }

  vm.save = function() {
    if (vm.form.$invalid) {
      return;
    }

    let validationResults = shiftScheduleValidationService.getValidationErrors(vm.plant.shiftSchedules);
    if (validationResults && validationResults.length) {
      _.each(validationResults, function(result){
        notifyService.error(result);
      });
      return;
    }

    vm.plant.morningMinutesStartMinute = deriveMinutesFromDate(vm.morningMinutesTime);

    let submit = plantService.updatePlant(vm.plant);
    loaderService.loadingPromise(submit.then(plantPersisted, notifyService.handleApiErrors));
  };

  vm.addShift = function() {
    loaderService.loadingPromise(newGuidService.getNewGuid('shift').then(function(newGuid) {
      vm.plant.shiftSchedules = vm.plant.shiftSchedules || [];
      vm.plant.shiftSchedules.push({
        id: newGuid,
        startMinute: null,
        stopMinute: null,
        name: null
      });
    }, notifyService.handleApiErrors));
  };

  vm.deleteShift = (shift: apsCommands.PlantCommandShiftSchedule) => {
    _.remove(vm.plant.shiftSchedules, { id: shift.id });
  };

  function getIntervals(minuteInterval: number): ShiftTime[] {
    let shiftTimes = [];
    let startOfDay = moment().startOf('day');
    for (let i = 0; i < 24 * 60; i += minuteInterval) {
      shiftTimes.push({ minute: i, clockTime: startOfDay.clone().add(i, 'm').format('LT') });
    }
    return shiftTimes;
  }

  function getMorningMinutesTime(): Date {
    return moment().startOf('day').add(data.plant.morningMinutesStartMinute,'m').toDate();
  }

  function getShiftTimes(): ShiftTime[] {
    return getIntervals(60);
  }

  vm.plant = _.cloneDeep(data.plant);
  vm.plants = data.plants;
  vm.timeZones = TimeZoneService.getTimeZones();
  vm.shiftTimes = getShiftTimes();
  vm.morningMinutesTime = getMorningMinutesTime();
  vm.countRejectPercents = uiUtilityService.getListOptionsFromEnum(apsEnums.CountRejectPercent);
  return vm;
}



// WEBPACK FOOTER //
// ./src/app/controllers/plants/editPlant.controller.ts